// extracted by mini-css-extract-plugin
export var externalLink = "_cy-0";
export var internalLinkLabel = "_cy-1";